import { PageId } from 'constants/pages'

export const getPathFromPageId = ({
  pageId,
  cohort,
  uuid,
  language,
  currentSearch,
  token,
}: {
  pageId: PageId
  cohort: string
  language: string
  uuid: string
  currentSearch: string
  token?: string
}): string => {
  const searchParams = new URLSearchParams(currentSearch)

  searchParams.set('cohort', cohort)
  searchParams.set('uuid', uuid)
  if (language) {
    searchParams.set('lang', language)
  }
  if (token) {
    searchParams.set('token', token)
  }

  return `${pageId}?${searchParams.toString()}`
}
